import AccordionHTML from "@components/accordions/accordionHTML";
import { Card } from "@components/cards/card";
import { ReactNode } from "react";
import { RaffleDefaultWordHowItWorksBuying } from "./buying";
import { RaffleDefaultWordHowItWorksDraws } from "./draws";

export function RaffleDefaultWordHowItWorks() {
  const items: { title: string; html: ReactNode }[] = [
    {
      title: "A aquisição",
      html: RaffleDefaultWordHowItWorksBuying(),
    },
    {
      title: "O sorteio",
      html: RaffleDefaultWordHowItWorksDraws(),
    },
  ];

  return (
    <>
      <Card>
        <div className="card-header">
          <div className="card-title">Rifa Tradicional de Palavras</div>
          <div className="card-category">
            Todo funcionamento e dúvidas frequentes sobre a Rifa Tradicional
            de Palavras que podem ser <strong>Nomes</strong>, <strong>Palavras</strong>, etc...
          </div>
        </div>
        <div className="card-body">
          {/* Titla */}
          <div className="col-md-12 text-center border-bottom pb-3">
            <span className="h5 fw-bold">Como Funciona?</span>
          </div>
          <div className="row">
            {/* Load the Explanations */}
            <AccordionHTML items={items} autoOpenKey={undefined} />
          </div>
        </div>
      </Card>
    </>
  );
}
